import React, { useEffect, useState, useRef } from 'react';
import OrderList from '../components/order/OrderList';
import { useOrderStats } from '../hooks/useOrderStats';

const OrderManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>(() => {
    // Initialize from localStorage or default to 'ALL'
    return localStorage.getItem('orderManagementActiveTab') || 'ALL';
  });
  
  const containerRef = useRef<HTMLDivElement>(null);

  // Persist active tab to localStorage and handle tab changes
  useEffect(() => {
    localStorage.setItem('orderManagementActiveTab', activeTab);
  }, [activeTab]);



  const handleTabChange = (newTab: string) => {
    if (newTab !== activeTab) {
      setActiveTab(newTab);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4" ref={containerRef}>
      <div className="max-w-7xl mx-auto">
        {/* <div className="flex items-center mb-6">
          <ShoppingBag className="h-8 w-8 text-indigo-600 mr-3" />
          <h1 className="text-2xl font-bold text-gray-900">Order Management</h1>
        </div> */}

        <OrderTabs activeTab={activeTab} setActiveTab={handleTabChange} />

        <div className="mt-6">
          <OrderList status={activeTab} />
        </div>
      </div>
    </div>
  );
};

export default OrderManagement;

interface OrderTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const OrderTabs = ({ activeTab, setActiveTab }: OrderTabsProps) => {
  const [loading, setLoading] = useState(false);
  const { data: ordersStats } = useOrderStats();

  const tabs: { key: string; label: string; count: number }[] = [
    { key: 'ALL', label: 'All Orders', count: ordersStats ? Object.values(ordersStats).reduce((sum: number, count: any) => sum + (count || 0), 0) : 0 },
    { key: 'PENDING', label: 'Pending', count: ordersStats?.PENDING },
    { key: 'CONFIRMED', label: 'Confirmed', count: ordersStats?.CONFIRMED },
    { key: 'SHIPPED', label: 'Shipped', count: ordersStats?.SHIPPED },
    { key: 'DELIVERED', label: 'Delivered', count: ordersStats?.DELIVERED },
    { key: 'CANCELLED', label: 'Cancelled', count: ordersStats?.CANCELLED }
  ];

  return (
    <div className="border-b border-gray-200">
      <nav className="flex flex-nowrap space-x-4 sm:space-x-8 overflow-x-auto">
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`
              whitespace-nowrap py-2 sm:py-4 px-1 border-b-2 font-medium text-xs sm:text-sm
              ${activeTab === tab.key
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            {tab.label}
            {loading ? (
              <span className="ml-2 py-0.5 px-2.5 rounded-full text-xs bg-gray-100">
                ...
              </span>
            ) : (
              <span className={`ml-2 py-0.5 px-2.5 rounded-full text-xs ${activeTab === tab.key ? 'bg-indigo-100 text-indigo-600' : 'bg-gray-100 text-gray-900'
                }`}>
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};